/**
 * @flow
 * @relayHash b52e3d3eba424d3f68452f04b1a26452
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmployeeWhere = {|
  and?: ?$ReadOnlyArray<?EmployeeWhere>,
  or?: ?$ReadOnlyArray<?EmployeeWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  numEmpleado?: ?ConditionInputType,
  docTipo?: ?ConditionInputType,
  docNum?: ?ConditionInputType,
  nit?: ?ConditionInputType,
  hasNit?: ?ConditionInputType,
  igss?: ?ConditionInputType,
  isIgssAffiliated?: ?ConditionInputType,
  isIrtraAffiliated?: ?ConditionInputType,
  primerNombre?: ?ConditionInputType,
  segundoNombre?: ?ConditionInputType,
  tercerNombre?: ?ConditionInputType,
  primerApellido?: ?ConditionInputType,
  segundoApellido?: ?ConditionInputType,
  apellidoCasada?: ?ConditionInputType,
  genero?: ?ConditionInputType,
  fechaNac?: ?ConditionInputType,
  lugarNacimiento?: ?ConditionInputType,
  edad?: ?ConditionInputType,
  estadoCivil?: ?ConditionInputType,
  nacionalidad?: ?ConditionInputType,
  paisOrigen?: ?ConditionInputType,
  numExpedienteExtranjero?: ?ConditionInputType,
  email?: ?ConditionInputType,
  phone?: ?ConditionInputType,
  direccion?: ?ConditionInputType,
  municipio?: ?ConditionInputType,
  departamentoGt?: ?ConditionInputType,
  zona?: ?ConditionInputType,
  grupoHabitacional?: ?ConditionInputType,
  nombreHabitacional?: ?ConditionInputType,
  vialidad?: ?ConditionInputType,
  numeroVialidad?: ?ConditionInputType,
  nombreVialidad?: ?ConditionInputType,
  tipoCasa?: ?ConditionInputType,
  numeroCasa?: ?ConditionInputType,
  referenciaAdicional?: ?ConditionInputType,
  profesion?: ?ConditionInputType,
  nivelAcademico?: ?ConditionInputType,
  puebloPertenencia?: ?ConditionInputType,
  comunidadLinguistica?: ?ConditionInputType,
  discapacidad?: ?ConditionInputType,
  cantidadHijos?: ?ConditionInputType,
  tipoSangre?: ?ConditionInputType,
  estatus?: ?ConditionInputType,
  fechaBaja?: ?ConditionInputType,
  motivoBaja?: ?ConditionInputType,
  observacionesBaja?: ?ConditionInputType,
  numeroReingresos?: ?ConditionInputType,
  foto?: ?ConditionInputType,
  userId?: ?ConditionInputType,
  supervisorId?: ?ConditionInputType,
  patronoId?: ?ConditionInputType,
  puestoId?: ?ConditionInputType,
  locationId?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  updatedBy?: ?ConditionInputType,
  updatedAt?: ?ConditionInputType,
  fullName?: ?ConditionInputType,
  fullNameSearch?: ?ConditionInputType,
  irtra?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type EmployeeSelectQueryVariables = {|
  where?: ?EmployeeWhere
|};
export type EmployeeSelectQueryResponse = {|
  +employees: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +fullName: ?string,
        +fullNameSearch: ?string,
        +estatus: ?string,
      |}
    |}>
  |}
|};
export type EmployeeSelectQuery = {|
  variables: EmployeeSelectQueryVariables,
  response: EmployeeSelectQueryResponse,
|};
*/


/*
query EmployeeSelectQuery(
  $where: EmployeeWhere
) {
  employees(where: $where, first: 10, orderBy: [primerNombre], order: ASC) {
    edges {
      node {
        id
        fullName
        fullNameSearch
        estatus
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "EmployeeWhere",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "employees",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": "ASC"
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": [
          "primerNombre"
        ]
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "EmployeeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "EmployeeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Employee",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullNameSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "estatus",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmployeeSelectQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmployeeSelectQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "EmployeeSelectQuery",
    "id": null,
    "text": "query EmployeeSelectQuery(\n  $where: EmployeeWhere\n) {\n  employees(where: $where, first: 10, orderBy: [primerNombre], order: ASC) {\n    edges {\n      node {\n        id\n        fullName\n        fullNameSearch\n        estatus\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '33b2de3a35f1278effb80a11ea9c82c3';
module.exports = node;
